"use client"

import { UserRoundCheck } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `UserRoundCheckIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const UserRoundCheckIcon = component(Icon)({ as: UserRoundCheck })
